import { BaseModel } from "@models/base.model";

export class PatientMedication extends BaseModel {
  PatientId: number;
  Description: string = '';
  FromDate: any;
  DisplayInList: boolean = true;
  RowOrder: number;
}

export class PatientAllMedicationList extends BaseModel {
  PatientMedication: Array<any> = new Array<any>();
}
